import {IntermediatePart} from "../../intermediatePart";
import {LOOK_OVERLAYS, ShowerBodyType} from "../../constants";
import {Shower} from "../../parts/shower";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import store from "../../../../../store";
import {setLookOverlayOpened} from "../../../../../actions/lookFunctions";

export default class Threshold extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'threshold';
    this.partName = 'Threshold';
    this.translateId = "visualizer.bathroom.shower.threshold";
    this.homePageTitle = 'Threshold';
    this.dbName = 'ShowerPan';
    this.isStoneFeature = true;
    this.selectedByUser = false;
    this.layerPriority = 7;
  }

  applyFeatureIfNotCompatible() {
    const parent = this.getParent();
    const shower = parent.getParent();
    shower.showerFloorIsActive = true;
    if (shower.layout && shower.showerTubComboIsActive()) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
    }
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);
    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }
    const parent = this.getParent();
    const shower = parent.getParent();
    if ((!shower.showerFloorIsActive || shower.showerTubComboIsActive()) && !window.location.hash.includes("visualizer")) {
      store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.notCompatiblePopup));
      return;
    }

    this.applyFeatureIfNotCompatible();

    this.getParent().selectedByUser = true;
    const showerFloor = shower.showerFloor;
    if (showerFloor && !showerFloor.selectedByUser) {
      const showerFloorAvailableFeatures = showerFloor.navigationSubItems();
      const currentThresholdName = this.getSplittedFeatureName();
      const sameShowerFloor = showerFloorAvailableFeatures.find(navItemFloor => {
        return navItemFloor.part.getSplittedFeatureName() === currentThresholdName
      });
      if (sameShowerFloor) {
        super.handleClick.call(sameShowerFloor.part);
        showerFloor.selectedByUser = false;
      }
    }
  }

  setLayers(layout) {

    if (this.getParent().showerTubComboIsActive() || !this.getParent().showerFloorIsActive) {
      super.hideLayers();
      return;
    }

    if (this.getParent().customBodyType === ShowerBodyType.Door) {
      const showerDoorParent = this.getParent().showerDoor;
      if (showerDoorParent && showerDoorParent.activeFeature) {
        const currentShowerPanCondition = showerDoorParent.activeFeature.metaData["ShowerPan"];
        if (!currentShowerPanCondition || (currentShowerPanCondition && !currentShowerPanCondition.includes("Threshold"))) {
          super.hideLayers();
          return;
        }
      }
    }
    const conditions = this.getArrayOfConditions();
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(conditions)
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  // getArrayOfConditions() {
  //   const layout = this.getParent().layout;
  //   const showerSize = this.getParent().showerSize();
  //   let showerDimensions = getMetadataByDimensions(this.getParent().showerDimensions());
  //
  //   const vanity = layout.parts[Vanity.id];
  //   let counterTopSize = vanity.counterTopSize(this);
  //   if (counterTopSize === '72in' && layout.type === 1 && (showerDimensions !== "Full" || showerDimensions !== "Pony")) {
  //     showerDimensions = "Full"
  //   }
  //
  //   return [{
  //     propName: 'ShowerSize',
  //     propValue: showerSize
  //   }, {
  //     propName: 'EX L',
  //     propValue: showerDimensions
  //   }];
  // }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerParent = this.getParent();
    conditions.push({
      propName: "ShowerSize",
      propValue: showerParent.showerSize()
    });
    return conditions
  }

  setZIndex(zIndexes) {
    if (this.getParent().activeSubType() === Shower.Type.Custom) {
      const zIndex = zIndexes.Shower.Threshold;
      if (zIndexes && this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (zIndexes && this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
